var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"append-icon":"mdi-magnify","label":_vm.label,"clearable":"","dense":""},model:{value:(_vm.searchText),callback:function ($$v) {_vm.searchText=$$v},expression:"searchText"}})}
var staticRenderFns = []

export { render, staticRenderFns }